export default __webpack_public_path__ + "static/media/welcome.10b902e0.svg";